import React from "react";
import {SupplyDTO} from "../../../../models/SupplyDTO";
import {OzonFilterToggle} from "../ui/OzonFilterToggle";
import {formatDate} from "../utils/date";
import {formatWarehouses} from "../utils/format";

export function CurrentSection({
                                   currentToShow,
                                   isLoading,
                                   ozonFilter,
                                   setOzonFilter,
                                   onDeleteRequest,
                                   innerRef,
                               }: {
    currentToShow: SupplyDTO[];
    isLoading: boolean;
    ozonFilter: boolean;
    setOzonFilter: (v: boolean) => void;
    onDeleteRequest: (s: SupplyDTO) => void;
    innerRef: React.RefObject<HTMLDivElement | null>;
}) {
    return (
        <>
            <div ref={innerRef} style={{ marginTop: 18 }}>
                <h2 className="supplies-section-title">Текущие поставки</h2>
                <p className="supplies-section-note">
                    Если требуется изменить текущие поставки — <b>обратитесь к разработчику</b>.
                </p>
            </div>

            <OzonFilterToggle name="currentFilter" value={ozonFilter} onChange={setOzonFilter} />

            <div className="admin-table-wrapper">
                <table className="admin_table supplies-table">
                    <thead>
                    <tr>
                        <th>Название</th>
                        <th>Дата отправки</th>
                        <th>Дата приёмки</th>
                        <th>Склады</th>
                        <th>Действия</th>
                    </tr>
                    </thead>

                    <tbody>
                    {isLoading && (
                        <tr>
                            <td colSpan={6} className="admin-table-loading">
                                <span className="admin-spinner" /> Загрузка...
                            </td>
                        </tr>
                    )}

                    {!isLoading &&
                        (currentToShow as any[]).map((s: any) => (
                            <tr key={s.id}>
                                <td>{s.title}</td>
                                <td>{formatDate(s.departureDate)}</td>
                                <td>{formatDate(s.acceptanceDate)}</td>
                                <td>{formatWarehouses(s.warehouses)}</td>
                                <td>
                                    <div className="supplies-actions">
                                        <button
                                            className="admin-button-secondary admin-button-secondary--danger"
                                            onClick={() => onDeleteRequest(s)}
                                        >
                                            Удалить
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}

                    {!isLoading && currentToShow.length === 0 && (
                        <tr>
                            <td colSpan={6} className="admin-table-empty">
                                Нет текущих для выбранного фильтра.
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </>
    );
}
